import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Details from './Details';
import ReportGroup from './ReportGroup';
import ReportFSNotes from './ReportFSNotes';
import ReportFSLines from './ReportFSLines';
import ReportAggregate from './ReportAggregate';
import ReportTestingSheet from './ReportTestingSheet';
import ReportCAP from './ReportCAP';
import ReportPAP from './ReportPAP';
import { AppBar, Toolbar, IconButton, Badge, Breadcrumbs, Link } from '@mui/material';
import { Menu as MenuIcon, Settings as SettingsIcon, Notifications as NotificationsIcon, Padding } from '@mui/icons-material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function Dashboard() {
    const { engagementCode, branchSubCode } = useParams();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [selectedTab, setSelectedTab] = React.useState(0);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static" color="default">
                <Toolbar>
                    <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                        <IconButton color="inherit">
                            <MenuIcon />
                        </IconButton>

                        <Typography variant="h5" sx={{ flexGrow: 1 }}>
                            Trial Balance
                        </Typography>
                    </Box>
                </Toolbar>
            </AppBar>

            {/* Page Header with Breadcrumb and Tab */}
            <Box sx={{ p: 2 }}>
                {/* Breadcrumb */}
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/">
                        My Engagement
                    </Link>
                    <Typography color="textPrimary">TCL-SA-31-02-23</Typography>
                </Breadcrumbs>

                {/* Back Button and Title */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                    <Typography variant="h4">TCL-SA-31-02-23</Typography>
                </Box>
            </Box>
            <Box sx={{ p: 2 }}>
                <Tabs value={value} onChange={handleChange} aria-label="profile tabs">
                    <Tab label="Details" {...a11yProps(0)} />
                    <Tab label="Grouping" {...a11yProps(1)} />
                    <Tab label="FS Notes" {...a11yProps(2)} />
                    <Tab label="FS Lines" {...a11yProps(3)} />
                    <Tab label="Aggregate" {...a11yProps(4)} />
                    <Tab label="Testing Sheet" {...a11yProps(5)} />
                    <Tab label="CAP" {...a11yProps(6)} />
                    <Tab label="PAP" {...a11yProps(7)} />
                </Tabs>
                <TabPanel
                    value={value}
                    index={0}
                    sx={{
                        p: 0,
                        '& .MuiBox-root': {
                            padding: '0px',
                        },
                    }}>
                    <Details engagementCode={engagementCode} branchSubCode={branchSubCode} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <ReportGroup engagementCode={engagementCode} branchSubCode={branchSubCode} />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <ReportFSNotes engagementCode={engagementCode} branchSubCode={branchSubCode} />
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <ReportFSLines engagementCode={engagementCode} branchSubCode={branchSubCode} />
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <ReportAggregate engagementCode={engagementCode} branchSubCode={branchSubCode} />
                </TabPanel>
                <TabPanel value={value} index={5}>
                    <ReportTestingSheet engagementCode={engagementCode} branchSubCode={branchSubCode} />
                </TabPanel>
                <TabPanel value={value} index={6}>
                    <ReportCAP engagementCode={engagementCode} branchSubCode={branchSubCode} />
                </TabPanel>
                <TabPanel value={value} index={7}>
                    <ReportPAP engagementCode={engagementCode} branchSubCode={branchSubCode} />
                </TabPanel>
            </Box>
        </Box>
    );
}

export default Dashboard;
